import DealProfileContainer from './DealProfileContainer'

export default DealProfileContainer
